import React from 'react';
import NewsletterSignup from '../common/Newsletter';

const Newsletter: React.FC = () => {
  return (
    <div
      className="
        relative
        flex 
        flex-col 
        bg-sea 
        items-center 
        px-[10vw] 
        md:px-[20vw] 
        xl:px-[30vw] 
        py-[15vh] 
        my-4
      "
    >
      {/* Corner Ropes (absolute) */}
      <img
        src="https://santaplaya-bucket.s3.amazonaws.com/rope1.webp"
        alt="Rope corner upper left"
        className="
          absolute 
          top-8 
          left-8 
          w-[8vw] 
          h-auto 
          pointer-events-none
        "
      />
      <img
        src="https://santaplaya-bucket.s3.amazonaws.com/rope2.webp"
        alt="Rope corner upper right"
        className="
          absolute 
          top-8 
          right-8 
          w-[8vw] 
          h-auto 
          mt-0
          pointer-events-none
        "
      />
      <img
        src="https://santaplaya-bucket.s3.amazonaws.com/rope3.webp"
        alt="Rope corner bottom left"
        className="
          absolute 
          bottom-8 
          left-8 
          w-[8vw] 
          h-auto 
          pointer-events-none
        "
      />
      <img
        src="https://santaplaya-bucket.s3.amazonaws.com/rope4.webp"
        alt="Rope corner bottom right"
        className="
          absolute 
          bottom-8 
          right-8 
          w-[8vw] 
          h-auto 
          pointer-events-none
        "
      />

      {/* Newsletter Content */}
      <img
        src="https://santaplaya-bucket.s3.amazonaws.com/NewletterText.webp"
        alt="Newsletter text"
      />
      <NewsletterSignup />
    </div>
  );
};

export default Newsletter;
